"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";

import { setProductQueries } from "@/utils/product/setProductQueries";
import type { QueryValueProps } from "@/utils/product/types";

function useProductQueries() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  return (value: QueryValueProps) => {
    const queries = setProductQueries({ searchParams, ...value });
    router.replace(`${pathname}?${queries}`, { scroll: false });
  };
}

export default useProductQueries;
